/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'basket-cancel': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M1.707.293l2.475 2.474L6.657.293A1 1 0 018.07 1.707L5.597 4.182l2.474 2.475A1 1 0 016.657 8.07L4.182 5.597 1.707 8.071A1 1 0 01.293 6.657l2.474-2.475L.293 1.707A1 1 0 011.707.293z" _fill="#000" fill-rule="evenodd"/>'
  }
})
